export const REACT_SELECT_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: 'var(--wf-control-height)',
    borderColor: state.isFocused ? 'var(--wf-color-action)' : 'var(--wf-color-border-strong)',
    borderRadius: 'var(--wf-radius-control)',
    backgroundColor: state.isDisabled
      ? 'var(--wf-color-surface-subtle)'
      : 'var(--wf-color-surface)',
    boxShadow: state.isFocused
      ? '0 0 0 3px color-mix(in srgb, var(--wf-color-focus) 10%, transparent)'
      : 'none',
    color: state.isDisabled ? 'var(--wf-color-text-muted)' : 'var(--wf-color-text)',
    fontFamily: 'var(--wf-font-sans)',
    fontSize: 'var(--wf-control-font-size)',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--wf-color-action)' : 'var(--wf-color-border-strong)',
    },
  }),
  input: (base) => ({
    ...base,
    color: 'var(--wf-color-text)',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--wf-color-text-muted)',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? 'var(--wf-color-text-muted)' : 'var(--wf-color-text)',
  }),
  menu: (base) => ({
    ...base,
    overflow: 'hidden',
    border: 'var(--wf-border-width) solid var(--wf-color-border)',
    borderRadius: 'var(--wf-radius-control)',
    backgroundColor: 'var(--wf-color-surface)',
    boxShadow: 'var(--wf-elevation-menu)',
    zIndex: 10,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: 'var(--wf-color-surface)',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'var(--wf-color-action)'
      : state.isFocused
        ? 'var(--wf-color-surface-subtle)'
        : 'var(--wf-color-surface)',
    color: state.isSelected
      ? 'var(--wf-color-on-action)'
      : state.isDisabled
        ? 'var(--wf-color-text-muted)'
        : 'var(--wf-color-text)',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    padding: 'var(--wf-space-2) var(--wf-space-3)',
    ':active': {
      backgroundColor: state.isSelected
        ? 'var(--wf-color-action-active)'
        : 'var(--wf-color-action-soft)',
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'var(--wf-color-surface-strong)',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--wf-color-text)',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--wf-color-text-secondary)',
    ':hover': {
      backgroundColor: 'var(--wf-color-danger)',
      color: 'var(--wf-color-on-action)',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'var(--wf-color-text-muted)',
    ':hover': {
      color: 'var(--wf-color-text)',
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--wf-color-text-muted)',
    ':hover': {
      color: 'var(--wf-color-text)',
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'var(--wf-color-border)',
  }),
  loadingIndicator: (base) => ({
    ...base,
    color: 'var(--wf-color-action-text)',
  }),
  loadingMessage: (base) => ({
    ...base,
    color: 'var(--wf-color-text-muted)',
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: 'var(--wf-color-text-muted)',
  }),
}
